module.exports = __webpack_public_path__ + "assets/044d587b3f1fd2dd1f1d3f95ea9d3de4.png";